import { QueryObserverBaseResult } from 'react-query'
import { AgentLanguage } from '../../../components/agent-language'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { getRecentApplications } from './requests/get-recent-applications'

export type UseRecentApplicationsResponse = Pick<
  QueryObserverBaseResult,
  'refetch'
> & {
  isLoading: boolean
  recentApplications: RecentApplications
}

type UseRecentApplications = (props: {
  organizationUuid: string
  enabled: boolean
}) => UseRecentApplicationsResponse

type ApplicationLanguage = 'JAVA' | 'DOTNET' | 'PROXY'

export interface RecentApplications {
  items: Array<{
    id: string
    name: string
  }>
  total: number
  languages: ApplicationLanguage[]
}

export const useRecentApplications: UseRecentApplications = ({
  organizationUuid,
  enabled
}) => {
  const {
    data: applications,
    isLoading,
    refetch
  } = useContrastQuery(
    [Query.RECENT_APPLICATIONS, organizationUuid],
    getRecentApplications,
    {
      organizationUuid
    },
    {
      enabled
    }
  )

  const recentApplications: RecentApplications = {
    items: !!applications
      ? applications.map(({ app_id: id, name }) => ({
          id,
          name
        }))
      : [],
    total: !!applications ? applications.length : 0,
    languages: !!applications
      ? Object.keys(
          applications
            .map(({ language }) => language)
            .reduce((acc, agentLanguageValue: string) => {
              const agentLanguageKey =
                AgentLanguage.fromValue(agentLanguageValue).getName()
              acc[agentLanguageKey] = true
              return acc
            }, {})
        ).map((k) => k as ApplicationLanguage)
      : []
  }

  return {
    isLoading,
    refetch,
    recentApplications
  }
}
